import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Modal, Button } from "antd";
import React from "react";
import { Severty, ShowToast } from "../helper/toast";
import callApi from "../constants/API/CallApi";

const { confirm } = Modal;

const DeleteRecord = ({
  _id,
  callback,
  icon = <DeleteOutlined />,
  setLoading = () => {},
  setRefresh = () => {},
  trigger = true,
  type = "Record",
}) => {
  const showConfirm = (recordId) => {
    confirm({
      icon,
      className: "tab_modal",
      content: "Are you sure you want to delete this record ?",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "Cancel",
      cancelButtonProps: {
        style: {
          backgroundColor: "#ff5722 ",
        },
      },
      okButtonProps: {
        style: {
          backgroundColor: "#ff5722",
        },
      },
      onOk() {
        deleteRecord(recordId);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const deleteRecord = async (recordId) => {
    setLoading(true);
    callApi({
      callback,
      payload: [recordId],
      onSuccess: ({ message }) => {
        setRefresh(new Date().getTime());
        ShowToast(`${type} deleted successfully`, Severty.SUCCESS);
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Button
      type="primary"
      title="Delete"
      danger
      icon={<DeleteOutlined />}
      onClick={() => trigger && showConfirm(_id)}
    />
  );
};

export default DeleteRecord;
